import { RefObject, useEffect } from 'react';

// Define the hook with TypeScript typing
export default function useClickOutside<T extends HTMLElement>(ref: RefObject<T>, callback: () => void): void {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    // Add click event listener
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // Clean up the event listener
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
}
